<span *ngFor="let part of parts; let last = last;" [class.redesign]="isRedesign" [class.commercial]="isCommercial">
  <span *ngIf="part">{{ part }}{{ last ? '' : ', '}}</span>
</span>
